// @flow
import React, { useEffect, useCallback, useRef } from 'react';
import type { User, Vehicle, Zone as ZoneType, Alert as AlertType, Car as CarType } from '../../types';
import Config from '../../models/Config';
import Car from '../../models/Car';
import Zone from '../../models/Zone';
import Alert from '../../models/Alert';
import SyncData from './SyncData';

export type Props = $ReadOnly<{
    userEntities: $ReadOnly<{[uid: string]: User}>,
    vehicleEntities: $ReadOnly<{[id: string]: Vehicle}>,

    fetchUsers: () => void,
    loadConfig: (data: $ReadOnlyArray<any>) => void,
    setConfig: (data: any) => void,
    unsetConfig: (data: any) => void,
    loadVehicles: (vehicles: $ReadOnlyArray<Vehicle>) => void,
    setVehicle: (vehicle: Vehicle) => void,
    unsetVehicle: (icao: string) => void,
    loadZones: (zones: $ReadOnlyArray<ZoneType>) => void,
    setZone: (zone: ZoneType) => void,
    unsetZone: (zone: ZoneType) => void,
    loadAlerts: (alerts: $ReadOnlyArray<AlertType>) => void,
    setAlert: (alert: AlertType) => void,
    unsetAlert: (alert: AlertType) => void,
    unsetCar: (car: CarType) => void
}>;

function Sync({ userEntities, vehicleEntities, fetchUsers, loadConfig, setConfig, unsetConfig, loadVehicles, setVehicle, unsetVehicle, loadZones, setZone, unsetZone, loadAlerts, setAlert, unsetAlert, unsetCar }: Props) {
    const userEntitiesRef = useRef();
    const vehicleEntitiesRef = useRef();
    userEntitiesRef.current = userEntities;
    vehicleEntitiesRef.current = vehicleEntities;

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    const handleVehicleChange = useCallback((vehicle) => {
        if(!vehicle.user && vehicleEntitiesRef.current) {
            const oldEntity = vehicleEntitiesRef.current[vehicle.icao];

            if(oldEntity && oldEntity.user) {
                unsetCar({ Icao: vehicle.icao });
            }
        }

        setVehicle(vehicle);

        if(vehicle.user && !userEntitiesRef.current[vehicle.user]) {
            fetchUsers();
        }
    }, [setVehicle, fetchUsers, unsetCar]);

    return (
        <React.Fragment>
            <SyncData
                label="config"
                Model={Config}
                onLoad={loadConfig}
                onAdd={setConfig}
                onChange={setConfig}
                onDelete={unsetConfig}
            />
            <SyncData
                label="cars"
                Model={Car}
                onLoad={loadVehicles}
                onAdd={setVehicle}
                onChange={handleVehicleChange}
                onDelete={unsetVehicle}
            />
            <SyncData
                label="zones"
                Model={Zone}
                onLoad={loadZones}
                onAdd={setZone}
                onChange={setZone}
                onDelete={unsetZone}
            />
            <SyncData
                label="alert"
                Model={Alert}
                onLoad={loadAlerts}
                onAdd={setAlert}
                onChange={setAlert}
                onDelete={unsetAlert}
            />
        </React.Fragment>
    );
}

export default Sync;